<template>
        <Modal v-model="downloadFileMdl" width="340" class-name="vertical-center-modal no-padding">
            <div slot="header" class="title">文件下载</div>
            <div class="close-btn" slot="close">
                <i class="iconfont icon-pop-close"></i>
            </div>
            <div class="download-files">
                <div class="content">
                    <div v-if="isArray" class="item" v-for="(file,index) in files" :key="index">
                        <div class="left">
                            <div class="name">
                                {{file.title || ''}}
                            </div>
                            <div class="info">
                                <p>
                                    文件名:
                                    <span class="file-name">{{file.name}}</span>
                                    <span class="file-size" v-if="file.size && egg === 'noEgg'">({{file.size}}KB)</span>
                                    <span class="file-size" v-if="file.size && egg !== 'noEgg'">({{file.size/1024}}MB)</span>
                                </p>
                                <p v-if="egg !== 'noEgg'&&isZhulogic">所需: <span class="red-font">{{addIntegral[index]}}</span> 恐龙蛋</p>
                                <p v-if="egg !== 'noEgg'">下载次数:{{file.downloads|collectNum}}次</p>
                            </div>
                        </div>
                        <div class="right download">
                            <button class="main-btn" @click="download(file,index)">
                                下载
                            </button>
                        </div>
                    </div>
                    <div v-if="!isArray" class="item">
                        <div class="left">
                            <!--<div class="name">-->
                                <!--{{file.title || ''}}-->
                            <!--</div>-->
                            <div class="info">
                                <p>
                                    文件名:
                                    <span class="file-name">{{filesObj.name}}</span>
                                    <span class="file-size" v-if="filesObj.size && egg === 'noEgg'">({{filesObj.size}}KB)</span>
                                    <span class="file-size" v-if="filesObj.size && egg !== 'noEgg'">({{filesObj.size/1024}}MB)</span>
                                </p>
                                <!--<p>所需恐龙蛋: <span class="red-font">{{addIntegral}}</span></p>-->
                            </div>
                        </div>
                        <div class="right download">
                            <button class="main-btn" @click="download(filesObj)">
                                下载
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <egglack-box ref="egglack" :text="text" :type="dialogType"></egglack-box>
        </Modal>
</template>
<script>
    import api from '../../api'
    import store from '../../store'
    import egglackBox from './eggLack.vue'
    import config from '../../config/config'
    export default{
        data(){
            return {
                downloadFileMdl:false,
                files:[],
                filesObj:{},
                addIntegral: [],
                text: '恐龙蛋不足，无法下载',
                dialogType: 1,
                fildId: [],
                isArray: true,
                egg: null,
                isZhulogic: config.isZhulogic
            }
        },
        methods:{
            open(files, egg){
                this.egg = egg
                this.isArray = files instanceof Array
                this.downloadFileMdl = true;
                if(this.isArray){
                    this.files = files;
                    if(files.length >= 1){
                        Array.forEach(files,(item, index) => {
                            this.fildId.push(item.id)
                        })

                    }
                }else{
                    this.filesObj = files;
                    if(files){
                        this.fildId.push(files.id)
                    }
                }
                if(this.egg !== 'noEgg'){
                    this.increase_consume_points()
                }
            },
            download(file,index){
                if(this.isZhulogic && this.egg !== 'noEgg'){
                    if(parseInt(this.balance()) < parseInt(this.addIntegral)){
                        this.$refs.egglack.open()
                        this.downloadFileMdl = false;
                        return false
                    }
                }
                if(this.isArray){
                    api.files.downloadFile(file.id)
                        .then((state)=>{
                            if(state!='success'){
                                this.$Message.error('下载失败,文件 key 错误');
                            }else{
                                this.downloadFileMdl = false;
                                this.files[index].downloads++;
                            }
                        });
                }else{
                    api.files.downloadFile(file.id)
                        .then((state)=>{
                            if(state!='success'){
                                this.$Message.error('下载失败,文件 key 错误');
                            }else{
                                this.downloadFileMdl = false;
                            }
                        });
                }

            },
            balance() {
                return this.$store.state.app.balance
            },
            increase_consume_points() {
                Array.forEach(this.fildId, (item, index) => {
                    let data = {
                        type: 'downSingleProduct',
                        fileId: item
                    }
                    api.eggPurchase.increase_consume_points(data)
                        .then(res =>{
                            this.addIntegral.push(Math.abs(res))
                        })
                })
            },
        },
        components: {
            egglackBox
        },
        created(){

        }
    }
</script>
<style>
    .download-files .content{
        padding:0 20px 44px;
    }
    .download-files .item{
        padding:20px 0;
        border-bottom:2px solid #F2F4F5;
        overflow: hidden;
    }
    .download-files .item .left{
        float:left;
        width:212px;
        text-align:left;
    }
    .download-files .item .right{
        float:right;
    }
    .download-files .item .name{
        font-size: 16px;
        margin-bottom:8px;
    }
    .download-files .item .info p{
        line-height:18px;
        margin-bottom:4px;
        color: #6C6F70;
    }
    .download-files .item .info p .file-name{
        display:inline-block;
        max-width:180px;
        -ms-text-overflow: ellipsis;
        text-overflow: ellipsis;
        white-space:nowrap;
        overflow: hidden;
        vertical-align: middle;
    }
    .download-files .item .download button{
        height:24px;
        line-height:24px;
        width:68px;
        display:block;
        font-size:12px;
        cursor:pointer;
    }
</style>